import { render, staticRenderFns } from "./x-cropper.vue?vue&type=template&id=1badcf3d&scoped=true&"
import script from "./x-cropper.vue?vue&type=script&lang=js&"
export * from "./x-cropper.vue?vue&type=script&lang=js&"
import style0 from "./x-cropper.vue?vue&type=style&index=0&id=1badcf3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1badcf3d",
  null
  
)

export default component.exports